(function () {
  'use strict';
  var SEP = ' | ';

  function getSelectedColor(picker) {
    var radios = picker.querySelectorAll('input[type=radio]:checked');
    for (var i = 0; i < radios.length; i++) {
      var n = radios[i].name || '';
      if (n === 'Color' || n.indexOf('Color-') === 0) return radios[i].value;
    }
    var sels = picker.querySelectorAll('select');
    for (var j = 0; j < sels.length; j++) {
      if (sels[j].name === 'options[Color]') return sels[j].value;
    }
    return null;
  }

  function applyFilter() {
    var galleries = document.querySelectorAll('media-gallery');
    for (var g = 0; g < galleries.length; g++) {
      var gallery = galleries[g];
      var scope = gallery.closest('section') || document;
      var picker = scope.querySelector('variant-selects') || document.querySelector('variant-selects');
      if (!picker) continue;
      var color = getSelectedColor(picker);
      if (!color) continue;
      var items = gallery.querySelectorAll('.product__media-item, .thumbnail-list__item');
      for (var k = 0; k < items.length; k++) {
        var img = items[k].querySelector('img');
        if (!img) continue;
        var alt = img.getAttribute('alt') || '';
        var idx = alt.indexOf(SEP);
        if (idx === -1) {
          items[k].style.display = '';
          continue;
        }
        items[k].style.display = alt.slice(0, idx) === color ? '' : 'none';
      }
    }
  }

  var t;
  function debouncedFilter() {
    clearTimeout(t);
    t = setTimeout(applyFilter, 60);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) debouncedFilter();
  });

  var mo = new MutationObserver(debouncedFilter);
  function observe() {
    var galleries = document.querySelectorAll('media-gallery');
    for (var i = 0; i < galleries.length; i++) {
      mo.observe(galleries[i], { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applyFilter(); observe(); });
  } else {
    applyFilter();
    observe();
  }
})();
